import styled, { keyframes } from 'styled-components';
import { getSizeStyles, getColor } from '../utils/loadingHelpers';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'};
`;

export const SpinnerElement = styled.div`
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.2);
  border-top-color: ${props => getColor(props.theme, props.color)};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;

  ${props => {
    const sizeStyles = getSizeStyles(props.size);
    return `
      width: ${sizeStyles.width};
      height: ${sizeStyles.height};
      border-width: ${sizeStyles.borderWidth};
    `;
  }}
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Loading/components/LoadingStyles.js